
<!-- Comments START -->
<div v-if="item.id && !item.isTemplate">
  <hr />
  <div class="label mt-2 mb-1">
    <div class="d-flex justify-content-between">
      <div>Comments</div>

      <div class="font-weight-bold cursor-pointer text-2xl" v-b-tooltip.hover :title="copyEmailToBoardTitle" @click="copyEmailToBoard">
        <i class="far fa-at fa-lg"></i>
      </div>
    </div>
  </div>

  <div class="position-relative">
    <textarea-autosize
      class="form-control comment-textarea"
      style="padding-right: 30px"
      rows="3"
      placeholder="Add a comment or paste an image..."
      v-model="comment"
      :min-height="75"
      @paste.native="paste"
      ref="commentInput"
      @keydown.native="handleEnter"
    ></textarea-autosize>
    <div
      class="form-control comment-textarea whitespace-pre-wrap"
      style="background: #eaeaea; font-size: 0.9rem; height: auto; white-space: pre-wrap"
      v-if="replyComment"
    >
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold">In reply to {{ replyComment.userTlc }}:</div>
        <div @click="replyComment = null" class="font-weight-bold cursor-pointer"><i class="far fa-times"></i></div>
      </div>

      <div class="ml-4 pl-2" style="border-left: solid 2px #eaeaea">
        {{ replyComment.text }}
      </div>
    </div>

    <div
      class="form-control comment-textarea whitespace-pre-wrap"
      style="background: #eaeaea; font-size: 0.9rem; height: auto; white-space: pre-wrap"
      v-if="replyAttachment"
    >
      <div class="d-flex justify-content-between">
        <div class="font-weight-bold">
          Commenting on file
          <i class="far fa-file"></i>
          {{ replyAttachment.fileName }}:
        </div>
        <div @click="replyAttachment = null" class="font-weight-bold cursor-pointer"><i class="far fa-times"></i></div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <button class="btn btn-sm btn-success mt-2" :disabled="!comment" @click="saveComment()">
      <i class="far fa-save"></i>
      Save comment
    </button>
  </div>

  <div v-if="showCommentsSection()">
    <hr />
    <div class="comments">
      <div v-for="comment in comments" class="comment" :key="comment.id">
        <div class="container-fluid">
          <div class="row">
            <div class="avatar col-1">
              <div v-if="comment.isSystemComment">SYS</div>
              <div v-else v-b-tooltip.hover.right :title="comment.userUserName">
                {{ comment.userTlc }}
              </div>
            </div>

            <div class="ml-1 col-11 mb-1" style="margin-right: -10px">
              <div class="container">
                <div class="row comment-header flex justify-content-between">
                  <div class="flex">
                    <span class="inline-block">
                      {{ comment.createdDate | formatDate }}
                    </span>
                    <span class="inline-block ml-1" v-if="comment.updatedDate && comment.updatedDate !== comment.createdDate">
                      (Edited: {{ comment.updatedDate | formatDate }})
                    </span>
                  </div>
                  <div>
                    <div v-if="couldEditComment(comment)" class="pl-2 replyToButton" @click="startEditComment(comment)">
                      <i class="far fa-pencil"></i>
                      Edit
                    </div>
                    <div class="pl-2 replyToButton" v-if="!comment.isSystemComment" @click="replyToComment(comment)">
                      <i class="far fa-reply"></i>
                      Reply
                    </div>
                  </div>
                </div>
              </div>

              <div class="container" v-if="!isEditing(comment.id)">
                <div class="row">
                  <div class="col-12">
                    <div :ref="'comment' + comment.id" class="comment-text" :class="{ 'comment-system': comment.isSystemComment }">
                      <div class="mb-2" v-if="comment.attachment">
                        <div class="font-weight-light underline cursor-pointer" @click="downloadAttachment(comment.attachment)">
                          <i class="far fa-file"></i>
                          {{ comment.attachment.fileName }}
                        </div>
                      </div>
                      <div v-linkify-directive="comment.text"></div>
                    </div>

                    <div
                      v-if="comment.parentComment"
                      class="comment-reply cursor-pointer"
                      :class="{ 'comment-system': comment.isSystemComment }"
                      @click="scrollToElement(comment.parentComment.id)"
                    >
                      <div class="font-weight-light">In reply to {{ comment.parentComment.userTlc }}:</div>
                      <div class="comment-reply-text" v-linkify-directive="comment.parentComment.text"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="position-relative">
                  <textarea-autosize
                    class="form-control comment-textarea"
                    rows="2"
                    placeholder="Add a comment..."
                    v-model="comment.text"
                    :min-height="50"
                    required
                  ></textarea-autosize>
                </div>
                <div class="d-flex justify-content-end">
                  <button class="btn btn-sm btn-success mt-2 mr-3" :disabled="!comment.text" @click="updateComment(comment)">
                    <i class="far fa-save"></i>
                    Save comment
                  </button>
                  <button class="btn btn-sm btn-primary mt-2" @click="cancelEditComment(comment)">
                    <i class="far fa-times"></i>
                    Cancel
                  </button>
                </div>
              </div>

              <div v-if="comment.isChildItem">
                <small>
                  Comment from linked item -
                  <router-link
                    :to="{
                      name: 'BoardItemDetail',
                      params: { itemid: comment.parentId },
                    }"
                  >
                    {{ comment.parentTitle }}
                  </router-link>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
